// src/data/testimonials.ts
import type { Language } from "@/lib/i18n";

interface Testimonial {
  id: number;
  name: string;
  role: string;
  image: string;
  rating: number;
  text: string;
}

const testimonialsDataByLang: Record<Language, Testimonial[]> = {
  id: [
    {
      id: 1,
      name: "Alexandra Müller",
      role: "Digital Nomad dari Jerman",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "Tinggal di KinKen Kost Elite seperti liburan permanen. Perpaduan desain Bali dengan kemewahan modern sempurna. Cocok untuk remote work dengan internet super cepat dan pemandangan menakjubkan.",
    },
    {
      id: 2,
      name: "Kenji Tanaka",
      role: "Ekspatriat Korporat",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "Sebagai orang yang pernah tinggal di Singapura dan Tokyo, saya bisa katakan KinKen menawarkan kemewahan yang sebanding dengan biaya lebih terjangkau. Layanan personal dan perhatian terhadap detail sangat exceptional.",
    },
    {
      id: 3,
      name: "Maya Dewi",
      role: "Marketing Director",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1976&auto=format&fit=crop",
      rating: 5,
      text: "Lokasi Renon sempurna - tenang namun sentral. Bangun dengan suara alam sambil menikmati amenities bintang 5 sungguh tak ternilai. Infinity pool dengan pemandangan sawah menjadi sanctuary harian saya.",
    },
    {
      id: 4,
      name: "David Chen",
      role: "Tech Entrepreneur",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "Coworking spaces dan meeting rooms di KinKen menjadi kantor kedua saya. Luxury living yang meningkatkan produktivitas - temuan langka di Bali. Layanan concierge 24/7 sangat exceptional.",
    },
    {
      id: 5,
      name: "Sophie Laurent",
      role: "Yoga Instructor & Wellness Coach",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1888&auto=format&fit=crop",
      rating: 5,
      text: "Energi di sini magical. Antara meditation garden, aktivitas wellness harian, dan suasana spiritual, KinKen mewujudkan esensi sejati dari spirit penyembuhan Bali. Pengalaman yang mengubah hidup.",
    },
  ],
  en: [
    {
      id: 1,
      name: "Alexandra Müller",
      role: "Digital Nomad from Germany",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "Living at KinKen Kost Elite feels like a permanent vacation. The perfect blend of Balinese design with modern luxury. Ideal for remote work with super fast internet and breathtaking views.",
    },
    {
      id: 2,
      name: "Kenji Tanaka",
      role: "Corporate Expatriate",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "Having lived in Singapore and Tokyo, I can say KinKen offers comparable luxury at a more affordable cost. The personalized service and attention to detail is truly exceptional.",
    },
    {
      id: 3,
      name: "Maya Dewi",
      role: "Marketing Director",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1976&auto=format&fit=crop",
      rating: 5,
      text: "The Renon location is perfect - peaceful yet central. Waking up to nature sounds while enjoying 5-star amenities is priceless. The infinity pool with rice paddy views has become my daily sanctuary.",
    },
    {
      id: 4,
      name: "David Chen",
      role: "Tech Entrepreneur",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1887&auto=format&fit=crop",
      rating: 5,
      text: "The coworking spaces and meeting rooms at KinKen have become my second office. Luxury living that boosts productivity - a rare find in Bali. The 24/7 concierge service is truly exceptional.",
    },
    {
      id: 5,
      name: "Sophie Laurent",
      role: "Yoga Instructor & Wellness Coach",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1888&auto=format&fit=crop",
      rating: 5,
      text: "The energy here is magical. Between the meditation garden, daily wellness activities, and spiritual ambiance, KinKen embodies the true essence of Bali's healing spirit. A life-changing experience.",
    },
  ],
};

// Backward compatibility
export const TESTIMONIALS_DATA = testimonialsDataByLang.id;

// New i18n function
export function getTestimonialsData(lang: Language = "id"): Testimonial[] {
  return testimonialsDataByLang[lang] || testimonialsDataByLang.id;
}
